import React from "react";

import { ReactComponent as EarthIcon } from "../../../assets/icons/earth.svg";
import { ReactComponent as GroupIcon } from "../../../assets/icons/org-team.svg";
import { ReactComponent as CashIcon } from "../../../assets/icons/cash.svg";
import { ReactComponent as GroupPlus } from "../../../assets/icons/group-plus-new.svg";
import { ReactComponent as LockIcon } from "../../../assets/icons/closed-lock.svg";
import { ReactComponent as ViewIcon } from "../../../assets/icons/viewer.svg";
import { CustomComponent, KeyOfAudiences } from "../../../store/types";

type AudienceIconsType = { [key in KeyOfAudiences]: CustomComponent };

export const audienceIcons: AudienceIconsType = {
  capital_seeker: CashIcon,
  everyone: EarthIcon,
  guest: GroupPlus,
  me: LockIcon,
  tenants_team: GroupIcon,
  viewer: ViewIcon,
};

export const AudienceIcon: React.FC<{ type: KeyOfAudiences }> = ({ type }) => {
  const AudienceIcon = audienceIcons[type];

  return AudienceIcon ? (
    <AudienceIcon className="comment-recipients__role-icon" />
  ) : (
    <GroupIcon />
  );
};
